require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/symbol/iterator.js
// module id = 67
// module chunks = 3 4 5 6 22 23 24 25 26 27 28 29 30 31 34 35 36 37 38 39 40 42 43 44 45 47